import React from "react";

interface MilestonesIconProps {
  fill?: string;
  width?: string;
  height?: string;
  isActive?: boolean;
}

const MilestonesIcon: React.FC<MilestonesIconProps> = ({
  fill = "#00132e",
  width = "24px",
  height = "24px",
  isActive = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 298.65 395.4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {isActive && (
      <defs>
        <filter
          id="filter0_dd_milestones_icon"
          x="-100%"
          y="-100%"
          width="500%"
          height="500%"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0823529 0 0 0 0 0.505882 0 0 0 0 0.929412 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_milestones" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0823529 0 0 0 0 0.505882 0 0 0 0 0.929412 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_milestones"
            result="effect2_dropShadow_milestones"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_milestones"
            result="shape"
          />
        </filter>
      </defs>
    )}

    <g filter={isActive ? "url(#filter0_dd_milestones_icon)" : undefined}>
      <g>
        <path
          d="M149.32,25.17c1.25,0,2.49.33,3.58.96l117,67.55c2.21,1.27,3.58,3.65,3.58,6.2v135.1c0,2.55-1.37,4.92-3.58,6.2l-117,67.55c-1.09.63-2.32.96-3.58.96s-2.49-.33-3.58-.96L28.75,241.17c-2.21-1.27-3.58-3.65-3.58-6.2V99.87c0-2.55,1.37-4.92,3.58-6.2L145.75,26.13c1.09-.63,2.32-.96,3.58-.96M149.32,0c-5.58,0-11.16,1.44-16.16,4.33L16.16,71.88C6.16,77.66,0,88.33,0,99.87v135.1c0,11.55,6.16,22.22,16.16,27.99l117,67.55c5,2.89,10.58,4.33,16.16,4.33s11.16-1.44,16.16-4.33l117-67.55c10-5.77,16.16-16.44,16.16-27.99V99.87c0-11.55-6.16-22.22-16.16-27.99L165.49,4.33c-5-2.89-10.58-4.33-16.16-4.33h0Z"
          fill={fill}
        />
        <path
          d="M174.43,137.42h-50.22c-5.52,0-10-4.48-10-10s4.48-10,10-10h50.22c5.52,0,10,4.48,10,10s-4.48,10-10,10Z"
          fill={fill}
        />
        <path
          d="M191.55,177.42h-84.44c-5.52,0-10-4.48-10-10s4.48-10,10-10h84.44c5.52,0,10,4.48,10,10s-4.48,10-10,10Z"
          fill={fill}
        />
        <path
          d="M164.88,217.42h-31.11c-5.52,0-10-4.48-10-10s4.48-10,10-10h31.11c5.52,0,10,4.48,10,10s-4.48,10-10,10Z"
          fill={fill}
        />
        <path
          d="M275.47,371.17h-10v-24.7c0-.93-.04-1.85-.11-2.76-1.41-18.62-17-33.32-35.97-33.32H69.26c-18.97,0-34.56,14.7-35.97,33.32-.07.91-.11,1.83-.11,2.76v24.7h-10.01c-12.63,0-22.9,10.28-22.9,22.91v1.32h298.11v-1.32c0-12.63-10.28-22.91-22.91-22.91ZM241.24,371.17H57.41v-24.7c0-.96.11-1.87.33-2.76.16-.7.4-1.38.7-2.05,1.87-4.26,6.13-7.04,10.82-7.04h160.13c4.37,0,8.37,2.4,10.45,6.27l.05.09.04.09.29.64c.29.64.53,1.31.69,2,.22.88.33,1.81.33,2.76v24.7Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export default MilestonesIcon;
